import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from 'src/environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-my-postcard',
  templateUrl: './my-postcard.component.html',
  styleUrls: ['./my-postcard.component.css'],
})
export class MyPostcardComponent implements OnInit {
  public form: FormGroup;
  loading = false;
  public submitted = false;
  constructor(
    public activatedRoute: ActivatedRoute,
    public fb: FormBuilder,
    public router: Router,
    public authenticationService: AuthenticationService,
    private ngxService: NgxUiLoaderService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
    });
  }

  get f() {
    return this.form.controls;
  }

  public onSubmit(values: Object): void {
    this.submitted = true;
    if (this.form.invalid) {
      return this.form.markAllAsTouched();
    }
    let formData = this.form.value;
    this.ngxService.start();
    this.authenticationService
      .createPostCard(formData)
      .subscribe((res: any) => {
        Swal.fire({
          title: '',
          html:
            'Your postcard has been sent!<br><br>' +
            'Send new postcards or create an event to attract more business',
          icon: 'success',
        });
        this.ngxService.stop();
        setTimeout(() => {
          this.router.navigate(['/my-postcard']);
        }, 50);
      });
  }

  goBack() {
    this.router.navigate(['/my-postcard']);
  }
}
